module.exports = __webpack_public_path__ + "fonts/font.2ed8a43.woff";